<template>
  <div id="container" class="chartCell">
    <!-- :width="currentWidth" :height="75" -->
    <line-chart :styles="myStyles" :chartData="getChartData()"></line-chart>
  </div>
</template>
<script>

import LineChart from '../BasicPercentageLineChart.vue';
import ThresholdColor from '@/mixins/ThresholdColor-APP_TARGET';

export default {

  components: {
    LineChart,
  },

  mixins: [ ThresholdColor ],
  
  props: {
    cellData: { type: Object, default: () => {} },
    percentageNumberOfDecimalPoints: {type: Number, default: 2},
    thresholds: null,
  },

  data() {
    return {
      toolTipDelay: { delay: { "show": 500, "hide": 100 } },
      currentWidth: undefined,
    };
  },
  
  mounted() {
    // console.log('ChartCell - mounted');
  },

  beforeDestroy() {
  },

  methods: {
    getChartData() {
        // console.log('getChartData');

        let retVal = {
          labels: [],
          datasets: [{
            label: this.$t('Webportal.Result'),
            backgroundColor: 'rgba(51, 51, 51, 0.7)',
            borderColor: 'rgba(51, 51, 51, 0.7)',
            pointRadius: 4,
            pointHoverRadius: 5,
            fill: false,
            pointBackgroundColor: [],
            pointBorderColor: [],
            data: []
          }]};
        let sourceWaves = undefined;
        let sourceItem = undefined;

        if (this.cellData)
        {
            if (this.cellData.rowType === 'group') {
                let items = this.cellData.data.items ?? this.cellData.data.collapsedItems;
                if (this.cellData.row.groupIndex === 0)
                {
                  // Check subitems on groupIndex = 1, if available
                  items = items?.[0].items ?? items?.[0].collapsedItems ?? items;
                  sourceItem = items?.[0].RootParent;
                }
                else
                  sourceItem = items?.[0].Parent;

                if (sourceItem)
                    sourceWaves = sourceItem.SurveyWave;

            } else if (this.cellData.rowType === 'data') {
                sourceItem = this.cellData.data;
                sourceWaves = sourceItem.SurveyWave;
                //console.log(1, sourceItem)
            }
        }

        if (sourceWaves) {
            // we don't need the total wave, so start with the first wave
            for (let i=1; i<sourceWaves.length; i++) {

                if (sourceWaves[i].Result != undefined) {

                  if (sourceWaves[i].Name != undefined) {
                    retVal.labels.push(sourceWaves[i].Name);
                  } else {
                    retVal.labels.push('label name N/A');
                  }

                  const val = this.getDecimalValue(sourceWaves[i].Result);
                  const color = this.getThresholdColor(this.thresholds, val, '#fff', sourceItem);

                  retVal.datasets[0].data.push(val);
                  retVal.datasets[0].pointBackgroundColor.push(color);
                  retVal.datasets[0].pointBorderColor.push(color);
                }
            }

            // if we only have one wave, we have to duplicate the value to get a line
            // instead of a single point
            if (retVal.datasets[0].data.length === 1) {
              retVal.labels.push(retVal.labels[0]);
              retVal.datasets[0].data.push(retVal.datasets[0].data[0]);
              retVal.datasets[0].pointBackgroundColor.push(retVal.datasets[0].pointBackgroundColor[0]);
              retVal.datasets[0].pointBorderColor.push(retVal.datasets[0].pointBorderColor[0]);
            }
        }

        // console.log(retVal);
        return retVal;
    },

    getDecimalValue(val) {
      let retVal = val;

      if (typeof(val) === 'string') {
        retVal = Number(retVal.replace('%', '').replace(',','.'));
      }

      return retVal;
    },

    customizeTooltip(arg) {
      //console.log('getResult');
      var retVal = 'N/A';

      if (arg.value != null && arg.value != undefined && !Number.isNaN(arg.value)) {
        retVal = (arg.value === 100 ? 
          this.$n(arg.value, { minimumFractionDigits: 0, maximumFractionDigits: 0}) :
          this.$n(arg.value, { minimumFractionDigits: this.percentageNumberOfDecimalPoints, maximumFractionDigits: this.percentageNumberOfDecimalPoints})) + '%';
      }

      return retVal;
    },
  },

  computed: {
    myStyles () {
      // console.log('ChartCell - currentWidth: ' + this.currentWidth);
      return {
        height: '75px',
        position: 'relative'
      }
    }
  }

};
</script>
<style>
  .chartCell {
    height: 75px;
    width: 98%; /*  we can't use 100% because in some mysterious cases 
                    the grid assumes the column too wide and the grid 
                    will hide the column for keeping responsive */
    display: block;
  }
</style>
